export default __webpack_public_path__ + "static/media/megane-rs-colour-3.d6540c82.jpg";